module.exports = __webpack_public_path__ + "media/components/footer/static/mountain__white-137dc2da8ca4edd75fa5bea6a204779a.svg";